import { ErrorHandler, Injectable } from "@angular/core";
import { MonitoramentoService } from "./monitoramento.service";

@Injectable()
export class ErroHandlerService extends ErrorHandler {

  constructor(private _monitoramentoService: MonitoramentoService) {
    super();
  }

  handleError(error: Error): void {
    this._monitoramentoService.logException(error);
  }
}